<nav [ngClass]="navbarBgcolor" class="navbar p-0">
  <div class="navbar-container container-fluid">
    <input type="checkbox" id="menuToggle" #menuToggle>
    <div class="hamburger-lines">
      <span class="line line1"></span>
      <span class="line line2"></span>
      <span class="line line3"></span>
    </div>
    <div class="navbar-menu">
      <ul class="menu-items p-0 mb-0">
        <li><a routerLink="home" [ngClass]="navbarHomepage" (click)="closeMenu(menuToggle)"
            routerLinkActive="active">Lobby</a></li>
        <li><a routerLink="play" [ngClass]="navbarHomepage" (click)="closeMenu(menuToggle)"
            routerLinkActive="active">Play</a></li>
        <li><a routerLink="puzzle" [ngClass]="navbarHomepage" (click)="closeMenu(menuToggle)"
            routerLinkActive="active">Puzzle</a></li>
        @if (loggedin()) {
        <li><a routerLink="database" [ngClass]="navbarHomepage" (click)="closeMenu(menuToggle)"
            routerLinkActive="active">Database</a></li>
        <li><a routerLink="openings" [ngClass]="navbarHomepage" (click)="closeMenu(menuToggle)"
            routerLinkActive="active">Opening</a></li>
      
            <li><a routerLink="news" [ngClass]="navbarHomepage" (click)="closeMenu(menuToggle)"
              routerLinkActive="active">News</a></li>
        <li class="login-mobile-btn"><a routerLink="settings" [ngClass]="navbarHomepage" (click)="closeMenu(menuToggle)" routerLinkActive="active">Setting</a></li>
        <li class="login-mobile-btn" (click)="profilePageRoute()"><a [ngClass]="navbarHomepage" (click)="closeMenu(menuToggle)" routerLinkActive="active">Profile</a></li>
        <li class="login-mobile-btn" (click)="onLogout()"><a class="dropdown-item sidebar-logout" [ngClass]="navbarHomepage" href="#">Log Out</a></li>
        }
        @if (!loggedin()) {
        <li class="login-mobile-btn">
          <div class="header-login">
          
            <button class="btn p-1 me-2 login-signup-btn" [ngClass]="navbarHomepage" routerLink="signup">
              Sign Up
            </button>
            <button class="btn p-1 login-signup-btn" [ngClass]="navbarHomepage" routerLink="login">Log In</button>
          </div>
        </li>
      }
  

       
      </ul>

    </div>
   

    <div class="header-login login-desktop-btn">
      @if (!loggedin()) {
      <button class="btn p-1 me-2 login-signup-btn" [ngClass]="navbarHomepage" routerLink="signup">
        Sign Up
      </button>
      <button class="btn p-1 login-signup-btn" [ngClass]="navbarHomepage" routerLink="login">Log In</button>
      }@else {
      <div class="dropdown-center">
        <i class="fa-solid fa-gear" data-bs-toggle="dropdown" aria-expanded="false"
          style="font-size: 17px;cursor: pointer;" [ngClass]="navbarHomepage"></i>
        <ul class="dropdown-menu" [ngClass]="settingDropdown">
          <li class="logout-section p-2 m-0" (click)="closeMenu(menuToggle)"><a [ngClass]="navbarHomepage"
              class="dropdown-item" routerLink="settings">
              <i class="fa-solid fa-gears me-3" [ngClass]="navbarHomepage"></i>Settings</a>
          </li>
          <li class="logout-section p-2 m-0" (click)="closeMenu(menuToggle)" (click)="profilePageRoute()"><a [ngClass]="navbarHomepage"
            class="dropdown-item" >
            <i class="fa-regular fa-user me-3" [ngClass]="navbarHomepage"></i>Profile</a>
        </li>
          <li class="p-2 m-0" (click)="onLogout()"><a class="dropdown-item" [ngClass]="navbarHomepage" href="#"><i
                class="fa-solid fa-power-off me-3" [ngClass]="navbarHomepage"></i>Log Out</a></li>
        </ul>
      </div>

      }

    </div>
    <div class="logo">
      <a routerLink="home"><img [src]="logoUrl" class="main-logo"  loading="lazy" alt=""></a>
    </div>
  </div>
</nav>